import { CollapsibleSection } from "components/collapsibleSection";
import { IPickupAttractionParticipantDetail } from "interfaces";
import { has } from "lodash";
import { Link } from "react-router-dom";

export const InformationSection = ({participantDetailData} : {participantDetailData: IPickupAttractionParticipantDetail | null}) => {
  const pickupNote = participantDetailData?.participant.pickup_note;
  const shouldShowPickupNote =
    has(participantDetailData?.participant, "pickup_note") && !!pickupNote;

  return (
    <CollapsibleSection 
      label="Information"
      defaultOpen={true}
    >
      <div className="grid gap-x-4 gap-y-6 px-4 py-4 text-sm sm:px-6 grid-cols-12 lg:gap-x-6" style={{wordBreak: "break-word"}}>
        <div className="grid gap-x-4 grid-cols-6 gap-y-6 col-span-full sm:col-span-6 sm:order-13">
          <div className="col-span-2">
            <p className="font-medium">
              Attendees ID
            </p>
          </div>
          <div className="col-span-4">
            <p>
              {participantDetailData?.participant.participant_id}
            </p>
          </div>
        </div>
        <div className="grid gap-x-4 grid-cols-6 gap-y-6 col-span-full sm:col-span-6 sm:order-3">
          <div className="col-span-2">
            <p className="font-medium">
              Seat
            </p>
          </div>
          <div className="col-span-4">
            <p>
              {participantDetailData?.participant.seat_number}
            </p>
          </div>
        </div>
        <div className="grid gap-x-4 grid-cols-6 gap-y-6 col-span-full sm:col-span-6 sm:order-5">
          <div className="col-span-2">
            <p className="font-medium">
            Order code
            </p>
          </div>
          <div className="col-span-4">
            <Link to={`/orders/${participantDetailData?.participant.order_code}`} className="w-fit font-medium text-brand-500 hover:underline">
              {participantDetailData?.participant.order_code}
            </Link>
          </div>
        </div>
        {participantDetailData?.participant.reference_code ? (
          <div className="grid gap-x-4 grid-cols-6 gap-y-6 col-span-full sm:col-span-6 sm:order-[9]">
            <div className="col-span-2">
              <p className="font-medium">
                Reference Code
              </p>
            </div>
            <div className="col-span-4">
              <p>
                {participantDetailData?.participant.reference_code}
              </p>
            </div>
          </div>
        ) : null}
        {shouldShowPickupNote ? (
          <div className="grid gap-x-4 grid-cols-6 gap-y-6 col-span-full sm:col-span-6 sm:order-[10]">
            <div className="col-span-2">
              <p className="font-medium">
                Note
              </p>
            </div>
            <div className="col-span-4">
              <p className="whitespace-pre-wrap">
                {pickupNote}
              </p>
            </div>
          </div>
        ) : null}
        <div className="grid gap-x-4 grid-cols-6 gap-y-6 col-span-full sm:col-span-6 sm:order-7">
          <div className="col-span-2">
            <p className="font-medium">
              Full name
            </p>
          </div>
          <div className="col-span-4">
            <p>
              {participantDetailData?.participant.full_name}
            </p>
          </div>
        </div>
        <div className="grid gap-x-4 grid-cols-6 gap-y-6 col-span-full sm:col-span-6 sm:order-2">
          <div className="col-span-2">
            <p className="font-medium">
            Event Name
            </p>
          </div>
          <div className="col-span-4">
            <p>
              {participantDetailData?.participant.event_name}
            </p>
          </div>
        </div>
        <div className="grid gap-x-4 grid-cols-6 gap-y-6 col-span-full sm:col-span-6 sm:order-4">
          <div className="col-span-2">
            <p className="font-medium">
              Ticket Name
            </p>
          </div>
          <div className="col-span-4">
            <p>
              {participantDetailData?.participant.ticket_name_en}
            </p>
          </div>
        </div>
        <div className="grid gap-x-4 grid-cols-6 gap-y-6 col-span-full sm:col-span-6 sm:order-6">
          <div className="col-span-2">
            <p className="font-medium">
              Ticket No
            </p>
          </div>
          <div className="col-span-4">
            <p>
              {participantDetailData?.participant.ticket_no}
            </p>
          </div>
        </div>
        <div className="grid gap-x-4 grid-cols-6 gap-y-6 col-span-full sm:col-span-6 sm:order-8">
          <div className="col-span-2">
            <p className="font-medium">
              Category
            </p>
          </div>
          <div className="col-span-4">
            <p>
              {participantDetailData?.participant.category}
            </p>
          </div>
        </div>
      </div>
    </CollapsibleSection>
    
  )
}
